import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCar, FaSearch } from "react-icons/fa";
import CarSearchWidget from "../helpers/CarSearchWidget";
import { carBrands } from "../../data/cars";

export default function CarsHub() {
  return (
    <div className="bg-white font-sans">
      <CarSearchWidget />

      <section className="bg-[#f8f9fc] px-4 py-14 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <nav className="mb-4 flex items-center gap-2 text-sm font-bold text-slate-500">
                <Link to="/" className="transition hover:text-[#2871d3]">
                  Home
                </Link>
                <FaArrowRight className="h-3 w-3" />
                <span className="text-slate-950">Car Rentals</span>
              </nav>
              <p className="mb-3 inline-flex rounded-full bg-blue-50 px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-[#2871d3]">
                Rental Partners
              </p>
              <h1 className="max-w-4xl text-3xl font-black tracking-tight text-slate-950 sm:text-5xl">
                Top car rental brands and guides
              </h1>
            </div>
            <p className="max-w-xl text-sm font-semibold leading-6 text-slate-500 sm:text-base">
              Browse our rental partners, compare vehicle fleets, and use the
              search above to find live car availability for your trip.
            </p>
          </div>

          <div className="mb-8 grid gap-4 rounded-[1.5rem] border border-slate-200 bg-white p-4 shadow-[0_16px_45px_rgba(15,23,42,0.06)] sm:grid-cols-3">
            {[
              ["Top", "Rental brands"],
              ["24/7", "Booking support"],
              ["Live", "Vehicle search"],
            ].map(([value, label]) => (
              <div
                key={label}
                className="rounded-[1.25rem] bg-[#f8f9fc] p-5 text-center"
              >
                <div className="text-3xl font-black text-[#2871d3]">
                  {value}
                </div>
                <div className="mt-1 text-sm font-black uppercase tracking-wide text-slate-500">
                  {label}
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {carBrands.map((brand) => (
              <Link
                key={brand.slug}
                to={`/cars/${brand.slug}`}
                className="group flex min-h-[230px] flex-col rounded-[1.5rem] border border-slate-200 bg-white p-6 shadow-[0_12px_35px_rgba(15,23,42,0.05)] transition-all duration-300 hover:-translate-y-1 hover:border-blue-100 hover:shadow-[0_22px_55px_rgba(40,113,211,0.14)]"
              >
                <div className="mb-5 flex items-start justify-between gap-4">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-50 text-lg font-black text-[#2871d3]">
                    {brand.code}
                  </div>
                  <span className="rounded-full bg-[#f8f9fc] px-3 py-1 text-xs font-black text-slate-500">
                    {brand.region}
                  </span>
                </div>
                <h2 className="text-xl font-black text-slate-950">
                  Book {brand.name} Rentals
                </h2>
                <p className="mt-3 line-clamp-3 text-sm font-medium leading-6 text-slate-500">
                  {brand.summary}
                </p>
                <div className="mt-auto flex items-center gap-2 pt-5 text-sm font-black text-[#2871d3]">
                  <FaSearch className="h-4 w-4" />
                  View guide and search cars
                  <FaCar className="ml-auto h-4 w-4 transition group-hover:translate-x-1" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
